import { DemGtnSummary } from '@/gtn/org/dem/gtnSummary/DemGtnSummary';
import { useMemo } from 'react';

export const DemForecastGtnTab = ({ forecastId }) => {
  const reqParam = useMemo(() => ({ forecastId }), [forecastId]);

  return (
    <DemGtnSummary
      dataPlugin="FORECAST_GTN_DATA_PLUGIN"
      filtersPlugin="FORECAST_GTN_FILTERS_DATA_PLUGIN"
      reqParam={reqParam}
    />
  );
};
